import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Button, Typography } from "@bookips/sds";
import Image from "next/image";
import { memo } from "react";
import { Skeleton } from "../components/Skeleton";
/**
 * 선택된 교재 정보 카드
 * 피그마: 썸네일 + 교재명 + 출판사명
 */ export const SelectedBookCard = /*#__PURE__*/ memo((param)=>{
    let { book , isLoading , onOpenDrawer  } = param;
    // book이 없거나 로딩 중이면 스켈레톤 표시
    const showSkeleton = isLoading || !book;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex flex-col rounded-lg bg-white p-5 shadow-sm", "max-sm:gap-3 max-sm:p-3"),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-4 max-sm:gap-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative h-[62px] w-11 shrink-0 overflow-hidden rounded",
                        children: showSkeleton ? /*#__PURE__*/ _jsx(Skeleton, {
                            className: "h-full w-full"
                        }) : book.thumbnail ? /*#__PURE__*/ _jsx(Image, {
                            src: book.thumbnail,
                            alt: book.title,
                            fill: true,
                            className: "rounded-md object-cover max-sm:w-[34px]",
                            sizes: "44px"
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "h-full w-full rounded-md bg-gray-50"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex min-w-0 flex-1 flex-col gap-1.5",
                        children: showSkeleton ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Skeleton, {
                                    className: "h-5 w-48"
                                }),
                                /*#__PURE__*/ _jsx(Skeleton, {
                                    className: "h-4 w-24"
                                })
                            ]
                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "h6",
                                    className: "text-strong max-sm:typo-subtitle1 break-keep",
                                    children: book.title || ""
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body2",
                                    className: "text-secondary max-sm:typo-caption break-keep",
                                    children: book.publisher || ""
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "stroke",
                color: "secondary",
                size: "sm",
                className: "hidden max-sm:flex max-sm:shrink-0",
                onClick: onOpenDrawer,
                children: "교재 변경"
            })
        ]
    });
});
SelectedBookCard.displayName = "SelectedBookCard";
export default SelectedBookCard;
